export const isMobileWidth = () => window.innerWidth < 768
